import textPageLoginENG from './pages/login/ENG.json'
import textButtonENG from './pages/button/ENG.json'
import textHeaderENG from './pages/header/ENG.json'
import textRoomENG from './pages/room/ENG.json'
import textAdvanceSearchENG from './pages/advanceSearch/ENG.json'
import textLocationENG from './pages/location/ENG.json'
import textUserENG from './pages/user/ENG.json'
import textRoleENG from './pages/role/ENG.json'
import textProfileENG from './pages/profile/ENG.json'
import textBGENG from './pages/bg/ENG.json'
import textFacNFoodENG from './pages/facNfood/ENG.json'
import textIOTENG from './pages/iot/ENG.json'
import textEventENG from './pages/event/ENG.json'
import textOrderENG from './pages/order/ENG.json'
import textSettingENG from './pages/setting/ENG.json'
import textReportENG from './pages/report/ENG.json'
import textMonitorENG from './pages/Monitor/ENG.json'
import textHotDeskENG from './pages/hotdesk/ENG.json'
import textErrorEng from './pages/error/ENG.json'

export default {
    login: {
        ...textPageLoginENG
    },
    button: {
        ...textButtonENG
    },
    header: {
        ...textHeaderENG
    },
    room: {
        ...textRoomENG
    },
    advanceSearch: {
        ...textAdvanceSearchENG
    },
    location: {
        ...textLocationENG
    },
    user: {
        ...textUserENG
    },
    role: {
        ...textRoleENG
    },
    profile: {
        ...textProfileENG
    },
    bg: {
        ...textBGENG
    },
    facNfood: {
        ...textFacNFoodENG
    },
    iot: {
        ...textIOTENG
    },
    event: {
        ...textEventENG
    },
    order: {
        ...textOrderENG
    },
    setting: {
        ...textSettingENG
    },
    report: {
        ...textReportENG
    },
    monitor: {
        ...textMonitorENG
    },
    noResult: "No Result",
    hotdesk: {
        ...textHotDeskENG
    },
   error:{
       ...textErrorEng
   },
    home:"Home"
}


// WEBPACK FOOTER //
// ./src/wording/en.js